import Admin from "../Admin";
import React from "react";
import CardAdminMarketingCampaignList from "../../../Component/Card/Admin/MarketingCampaign/CardAdminMarketingCampaignList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminMarketingCampaignList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminMarketingCampaignList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/marketingCampaign"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Marketing Campaigns" buttons={buttons} />
        );
    }
}
